import { useMutation } from 'react-query'
import { projectUseCase } from '../../factories'

const useCreateProject = () => {
  const {
    mutate: createProject, isLoading, data, error,
  } = useMutation(projectUseCase.createProject)

  return {
    createProject,
    isLoading,
    error,
    data,
  }
}

export default useCreateProject
